export default __webpack_public_path__ + "static/media/alan.1bcdccd2.jpeg";